// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2AFtA","overflowing":"ReadFullNote_overflowing__1PVw2"};